<template>
    <kgr-profile-part>
        <template #heading>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-row">
                <div class="kgr-postfix__fixed">
                    <h2
                        v-t="'Mitgliedschaft'"
                        class="kgr-headline kgr-headline--h3"
                    ></h2>
                </div>
                <div class="kgr-postfix__fixed">
                    <kgr-member-contract-state-icon :state="memberShortProfile.contractState" />
                </div>
                <kgr-member-dunning-icon v-if="memberShortProfile.isDunningActive" />
            </div>
        </template>

        <template #content>
            <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--200">
                <dt
                    v-t="'Aktueller Status'"
                    class="kgr-definitionList__term"
                ></dt>
                <dd
                    v-t="contractStatusText"
                    class="kgr-definitionList__definition"
                ></dd>
                <template v-if="memberShortProfile.accountsReceivableNumber">
                    <dt
                        v-t="'Debitorennummer'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.accountsReceivableNumber }}
                    </dd>
                </template>
            </dl>
            <br />
            <div class="kgr-row">
                <h4
                    v-t="'Aktueller Vertrag'"
                    class="kgr-headline kgr-headline--h4"
                ></h4>
            </div>
            <dl
                v-if="currentContract"
                class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--200">
                <dt class="kgr-definitionList__term">
                    {{ $t('Vertragsart') }}
                </dt>
                <dd class="kgr-definitionList__definition">
                    {{ $t(`memberShortProfile.contractType.${currentContract.type}`) }}
                </dd>
                <template v-if="currentContract.membershipNumber">
                    <dt class="kgr-definitionList__term">
                        {{ $t('memberShortProfile.membershipNumber') }}
                    </dt>
                    <dd class="kgr-definitionList__definition">
                        {{ currentContract.membershipNumber }}
                    </dd>
                </template>
                <dt class="kgr-definitionList__term">
                    {{ $t('Beginn') }}
                </dt>
                <dd class="kgr-definitionList__definition">
                    {{ currentContract.start.format('DD.MM.YYYY') }}
                </dd>
                <dt class="kgr-definitionList__term">
                    {{ $t('Ende') }}
                </dt>
                <dd class="kgr-definitionList__definition">
                    {{ currentContract.end ? currentContract.end.format('DD.MM.YYYY') : $t('offen') }}
                </dd>
            </dl>
            <div v-else>
                {{ $t('nicht vorhanden') }}
            </div>
            <br />
            <template v-if="memberShortProfile.linkedRecords.length">
                <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters">
                    <div class="kgr-postfix__fixed">
                        <h4
                            v-t="'Verknüpfte Datensätze'"
                            class="kgr-headline kgr-headline--h4"
                        ></h4>
                    </div>
                    <div
                        v-if="memberShortProfile.isMainRecord"
                        class="kgr-postfix__fixed"
                    >
                        <span
                            v-t="'Hauptdatensatz'"
                            class="kgr-badge kgr-badge--info"
                        ></span>
                    </div>
                </div>
                <table class="kgr-table">
                    <tbody>
                        <tr
                            v-for="(linkedRecord, index) in memberShortProfile.linkedRecords"
                            :key="index"
                            class="kgr-table__row kgr-table__row--top"
                        >
                            <td class="kgr-table__cell">
                                {{ linkedRecord.name }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ linkedRecord.institutionName }}
                                <span
                                    v-if="linkedRecord.isMain"
                                    v-t="'Hauptdatensatz'"
                                    class="kgr-badge kgr-badge--info kgr-ml1"
                                ></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div
                    v-if="!memberShortProfile.isMainRecord && !hasMainLinkedRecord"
                    v-t="'Es ist noch kein Hauptdatensatz festgelegt.'"
                    class="kgr-text"
                ></div>
                <br />
            </template>
            <template v-if="furtherContracts.length">
                <div class="kgr-postfix__fixed">
                    <h4
                        v-t="'Weitere Verträge'"
                        class="kgr-headline kgr-headline--h4"
                    ></h4>
                </div>
                <table class="kgr-table kgr-table--striped">
                    <thead>
                        <tr class="kgr-table__row kgr-table__row--top">
                            <th
                                v-t="'memberShortProfile.membershipNumber'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                            <th
                                v-t="'Vertragsart'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                            <th
                                v-t="'Beginn'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                            <th
                                v-t="'Ende'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="contract in memberShortProfile.contractHistory.further()"
                            :key="contract.id"
                            class="kgr-table__row"
                        >
                            <td class="kgr-table__cell">
                                {{ contract.membershipNumber }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ $t(`memberShortProfile.contractType.${contract.type}`) }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ contract.start.format('DD.MM.YYYY') }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ contract.end ? contract.end.format('DD.MM.YYYY') : '' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </template>
    </kgr-profile-part>
</template>

<script>
import KgrMemberContractStateIcon from '../MemberContractStateIcon.vue';
import MemberDunningIcon from '../MemberDunningIcon';
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-part-membership',
    components: {
        KgrMemberContractStateIcon,
        'kgr-member-dunning-icon': MemberDunningIcon,
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    data() {
        return {
            currentContract: null,
            furtherContracts: [],
        };
    },
    computed: {
        hasMainLinkedRecord() {
            return this.memberShortProfile.linkedRecords.some((linkedRecord) => linkedRecord.isMain);
        },
        contractStatusText() {
            if (this.memberShortProfile.contractState.status === 3) {
                return this.$t(`memberContractState.${this.memberShortProfile.contractState.status}`);
            }
            return this.$t(`memberContractState.${this.memberShortProfile.contractState.contractType}.${this.memberShortProfile.contractState.status}`);
        },
    },
    mounted() {
        this.currentContract = this.memberShortProfile.contractHistory.current();
        this.furtherContracts = this.memberShortProfile.contractHistory.further();
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
